import React, {useState} from 'react';
import {Field} from '../../Types';
import styled from "styled-components";
import {nullifyTableField} from "../../features/tableSlice";
import {useAppDispatch} from "../../hooks";
import {OverlayContainer} from "../misc/ImageViewer";

function NullifyBoolean({schema, pk, closeEditing}: {
    schema: Field,
    pk: string | number,
    closeEditing: () => void
}) {

    let [isOpen, setIsOpen] = useState(false);

    const dispatch = useAppDispatch();

    function updateField() {
        dispatch(nullifyTableField({field: schema.key, id: pk}))
        closeEditing()
    }

    return <>
        <Container onClick={() => setIsOpen(true)}>
            🔨 NULLIFY 🔨
        </Container>
        {isOpen && <OverlayContainer onClick={() => setIsOpen(false)} $isVisible={isOpen}>
            <Modal>
                <div>Ви точно хочете обнулити значення цього поля? (NULL)</div>
                <button className={'change'} onClick={() => updateField()}>
                    🔨 NULLIFY 🔨
                </button>
                <button onClick={() => setIsOpen(false)}>Ні</button>
            </Modal>
        </OverlayContainer>}
    </>
}

export default NullifyBoolean;

const Modal = styled.div`
    max-width: min(500px, 85vw);
    max-height: 80vh;
    width: 100%;
    color: var(--table-row-text-color);
    padding: .5rem;
    border-radius: .5rem;
    background-color: var(--table-row-odd-bg-color);

    display: flex;
    gap: .5rem;
    flex-flow: column;

    & > button {
        background: var(--table-action-color);
        padding: .2rem;
        cursor: pointer;
        border-radius: .2rem;
        display: flex;
        vertical-align: center;
        align-items: center;
        justify-content: center;
        font-size: 1rem;
        border: none;


        &:hover {
            filter: brightness(.85);
        }
    }
`

const Container = styled.button`

    margin-top: .5rem;
    width: 300px;
    background: var(--table-action-color);
    padding: .2rem;
    cursor: pointer;
    border-radius: .2rem;
    display: flex;
    vertical-align: center;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    border: none;

    &:hover {
        filter: brightness(.85);
    }
    
   
`
